import React from "react";
import cssClasses from "./PreselectConfig.module.css";
import { Box } from "@mui/material";
import DateComponent from "../../Subcomponents/DateComponent";
import DropDown from "../../Subcomponents/DropDown";
import CustomRadio from "../../Subcomponents/CustomRadio";
import { useState } from "react";
import { errorTost } from "../../Services/Toast";
import CustomInput from "../../Subcomponents/CustomInput";
import RupeeIcon from "../../Assets/Images/Sustenance/RupeeIcon.svg";

const PreselectConfig = ({
  eventTokens,
  setEventTokens,
  index,
  launchWiseToken,
}) => {
  return eventTokens?.token?.length > 0
    ? eventTokens.token?.map((val, inx) => {
      return (
        <Box className={cssClasses.mainTabPanelWrapper} sty>
          <span
            style={{
              fontSize: "2rem",
              fontFamily: "inter-semibold",
              paddingBottom: "2rem",
            }}
          >
            {val?.eventTokenId?.tokenId.name}
          </span>
          <div style={{ marginBottom: "2rem" }}>
            <div
              style={{ paddingBottom: "2rem" }}
              className={cssClasses.header}
            >
              <p className={cssClasses.headerText}>Timer Config</p>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "3rem",
                flexWrap: "wrap",
              }}
            >
              <DateComponent
                helperText={""}
                label={"Start Date Time"}
                maxDate={val?.preselectConfirmationConfig?.endDateTime}
                value={val?.preselectConfirmationConfig?.startDateTime}
                onChangeDate={(e) => {
                  const payload = [...launchWiseToken];
                  payload[index].token[inx].preselectConfirmationConfig =
                    payload[index].token[inx].preselectConfirmationConfig
                      ? payload[index].token[inx].preselectConfirmationConfig
                      : {};
                  payload[index].token[
                    inx
                  ].preselectConfirmationConfig.startDateTime = new Date(
                    e
                  ).getTime();
                  setEventTokens(payload);
                }}
              />
              <DateComponent
                helperText={""}
                label={"End Date Time"}
                minDate={val?.preselectConfirmationConfig?.startDateTime}
                value={val?.preselectConfirmationConfig?.endDateTime}
                onChangeDate={(e) => {
                  const payload = [...launchWiseToken];
                  payload[index].token[inx].preselectConfirmationConfig =
                    payload[index].token[inx].preselectConfirmationConfig
                      ? payload[index].token[inx].preselectConfirmationConfig
                      : {};
                  payload[index].token[
                    inx
                  ].preselectConfirmationConfig.endDateTime = new Date(
                    e
                  ).getTime();
                  setEventTokens(payload);
                }}
              />
              <DropDown
                list={["5", "10", "15", "30", "45", "60"]}
                label={"Timer in mins"}
                placeholder={"Timer in mins"}
                selectedValue={
                  val ? val?.preselectConfirmationConfig?.timer : ""
                }
                onChangeSelect={(e) => {
                  const payload = [...launchWiseToken];
                  payload[index].token[inx].preselectConfirmationConfig =
                    payload[index].token[inx].preselectConfirmationConfig
                      ? payload[index].token[inx].preselectConfirmationConfig
                      : {};
                  payload[index].token[
                    inx
                  ].preselectConfirmationConfig.timer = e;
                  setEventTokens(payload);
                }}
              />
            </div>
          </div>
          {/* <div className={cssClasses.labelToggleWrapper}>
                                            <div style={{ flex: "25%" }}>
                                                <p className={cssClasses.toggleLabel}>Start preselect confirmation:</p>
                                            </div>
                                            <div style={{ flex: "75%" }}>
                                                <CustomToggle checked={launchData?.blockTokenDistribution} setChecked={() => { setLaunchData((pre) => { pre.blockTokenDistribution = !pre.blockTokenDistribution; return { ...pre } }) }} />
                                            </div>
                                        </div> */}
          <div>
            <div
              style={{ paddingBottom: "2rem" }}
              className={cssClasses.header}
            >
              <p className={cssClasses.headerText}>Show Prices</p>
            </div>
            <div
              style={{
                display: "flex",
                gap: "3rem",
                marginBottom: "2rem",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "2rem",
                  alignItems: "center",
                  flex: "70%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "stretch",
                  }}
                >
                  <div>
                    <label class={cssClasses.container}>
                      <input
                        class={cssClasses.checkbox}
                        type="checkbox"
                        name=""
                        id=""
                        onChange={(e) => {
                          const payload = [...launchWiseToken];
                          payload[index].token[inx].showPreselectPrices =
                            payload[index]?.token[inx].showPreselectPrices
                              ? payload[index].token[inx].showPreselectPrices
                              : [];
                          if (
                            payload[index].token[
                              inx
                            ].showPreselectPrices.includes("BSP")
                          ) {
                            payload[index].token[
                              inx
                            ].showPreselectPrices.splice(
                              payload[index].token[
                                inx
                              ].showPreselectPrices.findIndex(
                                (e) => e === "BSP"
                              ),
                              1
                            );
                          } else {
                            payload[index].token[
                              inx
                            ].showPreselectPrices.push("BSP");
                          }
                          setEventTokens(payload);
                        }}
                        checked={val?.showPreselectPrices?.includes("BSP")}
                      />
                      <span class={cssClasses.checkmark}></span>
                    </label>
                  </div>
                  <p className={cssClasses.toggleLabel}>BSP</p>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "stretch",
                  }}
                >
                  <div>
                    <label class={cssClasses.container}>
                      <input
                        class={cssClasses.checkbox}
                        type="checkbox"
                        name=""
                        id=""
                        onChange={(e) => {
                          const payload = [...launchWiseToken];
                          payload[index].token[inx].showPreselectPrices =
                            payload[index].token[inx].showPreselectPrices
                              ? payload[index].token[inx].showPreselectPrices
                              : [];
                          if (
                            payload[index].token[
                              inx
                            ].showPreselectPrices.includes("GST")
                          ) {
                            payload[index].token[
                              inx
                            ].showPreselectPrices.splice(
                              payload[index].token[
                                inx
                              ].showPreselectPrices.findIndex(
                                (e) => e === "GST"
                              ),
                              1
                            );
                          } else {
                            payload[index].token[
                              inx
                            ].showPreselectPrices.push("GST");
                          }
                          setEventTokens(payload);
                        }}
                        checked={val?.showPreselectPrices?.includes("GST")}
                      />
                      <span class={cssClasses.checkmark}></span>
                    </label>
                  </div>
                  <p className={cssClasses.toggleLabel}>GST</p>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "stretch",
                  }}
                >
                  <div>
                    <label class={cssClasses.container}>
                      <input
                        class={cssClasses.checkbox}
                        type="checkbox"
                        name=""
                        id=""
                        onChange={(e) => {
                          const payload = [...launchWiseToken];
                          payload[index].token[inx].showPreselectPrices =
                            payload[index].token[inx].showPreselectPrices
                              ? payload[index].token[inx].showPreselectPrices
                              : [];
                          if (
                            payload[index].token[
                              inx
                            ].showPreselectPrices.includes("SDR")
                          ) {
                            payload[index].token[
                              inx
                            ].showPreselectPrices.splice(
                              payload[index].token[
                                inx
                              ].showPreselectPrices.findIndex(
                                (e) => e === "SDR"
                              ),
                              1
                            );
                          } else {
                            payload[index].token[
                              inx
                            ].showPreselectPrices.push("SDR");
                          }
                          setEventTokens(payload);
                        }}
                        checked={val?.showPreselectPrices?.includes("SDR")}
                      />
                      <span class={cssClasses.checkmark}></span>
                    </label>
                  </div>
                  <p className={cssClasses.toggleLabel}>SDR</p>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "stretch",
                  }}
                >
                  <div>
                    <label class={cssClasses.container}>
                      <input
                        class={cssClasses.checkbox}
                        type="checkbox"
                        name=""
                        id=""
                        onChange={(e) => {
                          const payload = [...launchWiseToken];
                          payload[index].token[inx].showPreselectPrices =
                            payload[index].token[inx].showPreselectPrices
                              ? payload[index].token[inx].showPreselectPrices
                              : [];
                          if (
                            payload[index].token[
                              inx
                            ].showPreselectPrices.includes("Total")
                          ) {
                            payload[index].token[
                              inx
                            ].showPreselectPrices.splice(
                              payload[index].token[
                                inx
                              ].showPreselectPrices.findIndex(
                                (e) => e === "Total"
                              ),
                              1
                            );
                          } else {
                            payload[index].token[
                              inx
                            ].showPreselectPrices.push("Total");
                          }
                          setEventTokens(payload);
                        }}
                        checked={val?.showPreselectPrices?.includes("Total")}
                      />
                      <span class={cssClasses.checkmark}></span>
                    </label>
                  </div>
                  <p className={cssClasses.toggleLabel}>Total</p>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "2rem",
                  }}
                >
                  <label
                    className={cssClasses.toggleLabel}
                    style={{ width: "120px" }}
                  >
                    {/* Price Discount(%) */}
                    Price Discount
                  </label>
                  <div style={{ width: "150px" }}>
                    <CustomInput
                      inputType="number"
                      value={val?.priceDiscount}
                      image={"true"}
                      position="start"
                      labelText={RupeeIcon}
                      handleChange={(_value) => {
                        // if (!isNaN(_value) && _value <= 100 && _value >= 0) {
                        if (!isNaN(_value) && _value >= 0) {
                          const payload = [...launchWiseToken];
                          payload[index].token[inx].priceDiscount = _value;
                          setEventTokens(payload);
                        }
                      }}
                    /></div>
                </div>
              </div>
            </div>
          </div>
          {eventTokens?.token?.length > 0 && (
            <div style={{ marginTop: "2rem" }}>
              <div
                style={{ paddingBottom: "2rem" }}
                className={cssClasses.header}
              >
                <p className={cssClasses.headerText}>Confirmation Config</p>
              </div>
              {
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "2rem",
                    fontSize: "1.6rem",
                  }}
                >
                  {/* <p>{val?.eventTokenId?.tokenId.name}</p> */}
                  <CustomRadio
                    value={
                      val.autoConfirmation
                        ? "Auto Confirmation"
                        : "Lead Confirmation"
                    }
                    optionList={["Auto Confirmation", "Lead Confirmation"]}
                    onChangeValue={(e) => {
                      if (
                        new Date().getTime() >
                        val?.eventTokenId?.startDateTime &&
                        new Date().getTime() < val?.eventTokenId?.endDateTime
                      ) {
                        const payload = [...launchWiseToken];
                        payload[index].token[inx].autoConfirmation =
                          e === "Auto Confirmation" ? true : false;
                        setEventTokens(payload);
                      } else {
                        errorTost(
                          "Auto Confirmation is only allowed on event day"
                        );
                      }
                    }}
                  />
                </div>
              }
            </div>
          )}
          {val?.eventTokenId?.prerequisiteId && (
            <div style={{ marginTop: "2rem" }}>
              <div
                style={{ paddingBottom: "2rem" }}
                className={cssClasses.header}
              >
                <p className={cssClasses.headerText}>Prerequisite Checkpoints</p>
              </div>
              <div style={{display:"flex",gap:"2rem"}}>
              <div
                  style={{
                    display: "flex",
                    alignItems: "stretch",
                  }}
                >
                  <div>
                    <label class={cssClasses.container}>
                      <input
                        class={cssClasses.checkbox}
                        type="checkbox"
                        name=""
                        id=""
                        onChange={(e) => {
                          const payload = [...launchWiseToken];
                          payload[index].token[inx].checkpoint =
                            payload[index].token[inx].checkpoint
                              ? payload[index].token[inx].checkpoint
                              : {};
                          if (
                            payload[index].token[
                              inx
                            ].checkpoint?.checkpoint1
                          ) {
                            payload[index].token[
                              inx
                            ].checkpoint.checkpoint1 = false
                          } else {
                            payload[index].token[
                              inx
                            ].checkpoint.checkpoint1 = true
                          }
                          setEventTokens(payload);
                        }}
                        checked={val?.checkpoint?.checkpoint1}
                      />
                      <span class={cssClasses.checkmark}></span>
                    </label>
                  </div>
                  <p className={cssClasses.toggleLabel}>Checkpoint1</p>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "stretch",
                  }}
                >
                  <div>
                    <label class={cssClasses.container}>
                      <input
                        class={cssClasses.checkbox}
                        type="checkbox"
                        name=""
                        id=""
                        onChange={(e) => {
                          const payload = [...launchWiseToken];
                          payload[index].token[inx].checkpoint =
                            payload[index].token[inx].checkpoint
                              ? payload[index].token[inx].checkpoint
                              : {};
                          if (
                            payload[index].token[
                              inx
                            ].checkpoint?.checkpoint2
                          ) {
                            payload[index].token[
                              inx
                            ].checkpoint.checkpoint2 = false
                          } else {
                            payload[index].token[
                              inx
                            ].checkpoint.checkpoint2 = true
                          }
                          setEventTokens(payload);
                        }}
                        checked={val?.checkpoint?.checkpoint2}
                      />
                      <span class={cssClasses.checkmark}></span>
                    </label>
                  </div>
                  <p className={cssClasses.toggleLabel}>Checkpoint2</p>
                </div>
                </div>
            </div>
          )}
        </Box>
      );
    })
    : "";
};

export default PreselectConfig;
